module.exports = __webpack_public_path__ + "img/375.ea6ec510.jpg";